
const isProduction = process.env.REACT_APP_STAGE === 'production';

// const isProduction = true;
const levels = {
  error: 0,
  warn: 1,
  info: 2,
  debug: 3,
};

// Convert numeric log level to string if needed
const getLogLevel = () => {
  const level = process.env.REACT_APP_LOG_LEVEL;
  if (!level) return 'info';
  
  // If it's a number, convert to corresponding level
  const numLevel = parseInt(level);
  if (!isNaN(numLevel)) {
    switch(numLevel) {
      case 0: return 'error';
      case 1: return 'warn';
      case 2: return 'info';
      case 3: return 'debug';
      default: return 'info';
    }
  }
  
  // If it's a string, use it directly
  return level;
};

let currentLevel = isProduction ? levels.warn : levels[getLogLevel()];

const logger = {
  log: (level, ...args) => {
    if (levels[level] <= currentLevel) {
      console[level](...args);
    }
  },
  error: (...args) => logger.log('error', ...args),
  warn: (...args) => logger.log('warn', ...args),
  info: (...args) => logger.log('info', ...args),
  debug: (...args) => {
    if (!isProduction) {
      logger.log('debug', ...args);
    }
  },
  setLevel: (level) => {
    if (!isProduction && levels[level] !== undefined) {
      currentLevel = levels[level];
    } else {
      console.warn('Log level changes are not allowed in production.');
    }
  },
};

export default logger;
